import { legacyLodashMapper as toCoordinatesLegacyMapper } from '@data/api/mappers/places/toCoordinates'
import locationSchema from '@data/schemas/location'
import { logSchemaValidationError } from '@data/schemas/util/logSchemaValidationError'
import { get } from 'lodash-es'

const legacyLodashMapper = (data: Json): TLocation => ({
    city: get(data, 'city', null),
    country: {
        id: get(data, 'country.iocCode'),
        name: get(data, 'country.name'),
        iocCode: get(data, 'country.iocCode'),
        // Justification for ignoring this: we don't want to touch the old schemas, even if they're incorrect, until we are ready to switch to the new schema
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        nationality: get(data, 'country.nationality'),
    },
    coordinates: toCoordinatesLegacyMapper(data),
})

export const toLocation = (data: Json): TLocation => {
    try {
        return locationSchema.validateSync(data)
    } catch (e) {
        logSchemaValidationError(`TLocation`, e, data)

        return legacyLodashMapper(data)
    }
}
